import React, { useState, useEffect } from "react";
import GiftsContainer from "./GiftsContainer";
import HomeOccasionsContainer from "../components/HomeOccasionsContainer";

const Home = ({ selectedCountry }) => {
  const [productList, setProductList] = useState([]);
  const [occasionsInfoList, setOccasionsInfoList] = useState([]);
  const [loadingError, setLoadingError] = useState(null);

  const [currentIndexes, setCurrentIndexes] = useState([]);

  useEffect(() => {
    try {
      const productJsonData = require(`../data/occasions/${selectedCountry}/home.json`);
      setProductList(productJsonData.productList);
      setCurrentIndexes(productJsonData.productList.map(() => 0));

      const occasionsJsonData = require(`../data/occasions/${selectedCountry}/topOccasions.json`);
      setOccasionsInfoList(occasionsJsonData.occasionsInfoList);
    } catch (err) {
      setLoadingError("Failed to load data.");
    }
  }, [selectedCountry]);

  if (productList === null) {
    return <div />;
  }

  if (loadingError !== null) {
    return (
      <div>
        <p
          style={{
            color: "red",
            justifySelf: "center",
            height: "100vh",
            alignContent: "center",
          }}
        >
          {loadingError}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          marginTop: 10,
        }}
      ></div>

      <div>
        <p
          style={{
            marginLeft: "15%",
            marginRight: "15%",
            paddingTop: 20,
            textAlign: "center",
            fontSize: "15px",
            fontFamily: "Alex Brush, cursive",
          }}
        >
          <span>
            Searching for the perfect gift for every occasion !!! ...... At
            Gifts4Occasion, explore a curated selection of premium gifts for
            birthdays, holidays, anniversaries, and more. Simply choose your
            occasion, and discover the best gift options, handpicked to make
            every gift memorable.
          </span>
        </p>
      </div>

      <p
        style={{
          marginTop: "20px",
          marginLeft: "20px",
          textAlign: "center",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        Top occasions
      </p>
      <HomeOccasionsContainer
        occasionsInfoList={occasionsInfoList}
        selectedCountry={selectedCountry}
      />
      <p
        style={{
          marginTop: "20px",
          marginLeft: "20px",
          textAlign: "center",
          fontSize: "24px",
          fontWeight: "bold",
        }}
      >
        Shop the Best Curated Gifts for Every Occasion – Perfect for All!
      </p>
      <div>
        <GiftsContainer
          productList={productList}
          currentIndexes={currentIndexes}
          setCurrentIndexes={setCurrentIndexes}
        />
      </div>
    </div>
  );
};

export default Home;
